{
  "partner": {
    "common": {
      "refresh": "Actualiser",
      "loadError": "Impossible de charger les données.",
      "retry": "Réessayer",
      "adminOnlyTitle": "Réservé aux admins partenaires"
    },
    "settings": {
      "adminOnlyDescription": "Les paramètres sont réservés aux admins partenaires.",
      "tabs": {
        "users": "Gestion des utilisateurs"
      }
    },
    "team": {
      "inviteSuccess": "Invitation envoyée",
      "inviteError": "Impossible d'envoyer l'invitation.",
      "activateSales": {
        "action": "Activer pour les ventes",
        "successCreated": "Contact HubSpot créé et lié – l'utilisateur peut désormais soumettre des leads.",
        "successLinked": "Lié au contact HubSpot – l'utilisateur peut désormais soumettre des leads.",
        "error": "Échec de l'activation des ventes (droit d'écriture HubSpot manquant ?)."
      },
      "adminOnlyDescription": "La gestion des utilisateurs est réservée aux admins partenaires.",
      "membersTitle": "Utilisateurs Bliks",
      "membersEmpty": "Aucun utilisateur pour l'instant.",
      "columns": {
        "name": "Nom",
        "email": "E-mail",
        "role": "Rôle",
        "status": "Statut",
        "position": "Poste",
        "salesStatus": "Statut commercial"
      },
      "salesStatus": {
        "active": "Activé pour les ventes",
        "inactive": "Non activé"
      },
      "addMember": "Ajouter un membre",
      "dialog": {
        "createTitle": "Inviter un membre",
        "editTitle": "Modifier le membre",
        "description": "Le nom, l'e-mail et le rôle du membre de l'équipe.",
        "submitCreate": "Inviter"
      },
      "createSuccess": "Invitation envoyée",
      "createError": "Impossible de créer le membre.",
      "updateSuccess": "Modifications enregistrées",
      "updateError": "Impossible d'enregistrer les modifications.",
      "suspendSuccess": "Membre suspendu",
      "unsuspendSuccess": "Membre réactivé",
      "deleteSuccess": "Membre supprimé",
      "deleteTitle": "Supprimer le membre",
      "deleteDescription": "Ce membre sera définitivement supprimé du compte partenaire."
    },
    "home": {
      "title": "Accueil",
      "greeting": "Bon retour, {{name}}",
      "greetingAnonymous": "Bon retour",
      "subtitle": "Les actualités de BLIKS IO et tout ce dont vous avez besoin pour vendre.",
      "quickLinks": "Accès rapide",
      "links": {
        "sales": {
          "title": "Ventes",
          "description": "Leads, liste de contacts et pipeline dans l'app de vente."
        },
        "infoHub": {
          "title": "Info Hub",
          "description": "Documents et vidéos pour vos rendez-vous."
        }
      },
      "news": {
        "title": "Actualités",
        "empty": "Aucune actualité pour le moment.",
        "error": "Les actualités n’ont pas pu être chargées.",
        "pinned": "Épinglé",
        "storyLabel": "Carrousel",
        "goTo": "Actualité {{index}} sur {{count}}"
      },
      "recentMaterial": {
        "title": "Nouveau dans l’Info Hub",
        "all": "Tous les documents"
      }
    },
    "infoHub": {
      "title": "Info Hub",
      "subtitle": "Documents et vidéos de BLIKS IO pour votre activité commerciale.",
      "language": "Langue",
      "searchLanguage": "Rechercher une langue …",
      "noLanguage": "Aucune langue trouvée.",
      "search": "Rechercher des documents …",
      "category": "Catégorie",
      "categories": {
        "salesDocuments": "Documents de vente",
        "presentations": "Présentations",
        "caseStudies": "Études de cas",
        "productInfo": "Informations produit"
      },
      "tabs": {
        "files": "Fichiers ({{count}})",
        "videos": "Vidéos ({{count}})"
      },
      "columns": {
        "title": "Document",
        "languages": "Langues",
        "format": "Format"
      },
      "new": "Nouveau",
      "download": "Télécharger",
      "downloadTitle": "Télécharger « {{title}} » en {{language}}",
      "otherLanguages": "Télécharger « {{title}} » dans une autre langue",
      "downloadIn": "Télécharger en",
      "downloadFailed": "Le téléchargement n’a pas pu démarrer.",
      "fallbackHint": "Pas disponible en {{wanted}} ; vous recevez la version {{language}}.",
      "playVideo": "Lire la vidéo « {{title}} »",
      "empty": "Aucun document pour le moment.",
      "noVideos": "Aucune vidéo pour le moment.",
      "errorTitle": "Info Hub indisponible",
      "errorDescription": "Les documents n’ont pas pu être chargés.",
      "availableIn": "Disponible en {{languages}}",
      "moreLanguages": "+{{count}}"
    },
    "tasks": {
      "title": "Tâches",
      "subtitle": "Ce qui vous a été confié et reste ouvert"
    }
  }
}
